/* FSL DEVICE, EMPAT GERAKAN

   Source BYQ memakai interaksi Webflow bernomor data-w-id yang tidak ikut
   terbawa saat komponennya diangkat ke Liquid. Yang dibangun ulang di sini
   empat hal, dan angkanya diambil dari config __ix source-nya:

     a. batang tumbuh berurutan, 1000ms easeInOut, jeda 500ms antar batang
     b. angka berhitung naik, mulai bersamaan dengan teksnya
     c. kolom media naik dari 50px, 600ms
     d. parallax pada medianya, mengikuti progress scroll section

   KENAPA penghitung global TIDAK DIPAKAI ULANG DI SINI

   Berkas itu memindai [data-counter] sedokumen dan memberi TIAP elemen
   ScrollTrigger sendiri, once, start top 88%. Kontraknya tidak punya tempat
   untuk delay per elemen.

   Di section ini angkanya bukan pertunjukan sendiri. Dia satu jalur di dalam
   timeline yang sama dengan batangnya, dan harus mulai tepat saat teksnya
   muncul, yaitu 500ms setelah batangnya sendiri berangkat. Kalau dipasang
   data-counter, angka ketiga sudah selesai berhitung sebelum batang ketiganya
   mulai tumbuh, karena pemicunya beda dan tidak ada yang menyelaraskannya.

   Lebih buruk lagi, dua tween akan memperebutkan textContent yang sama:
   milik penghitung global dan milik timeline ini. Yang menang bergantung
   urutan frame, dan itu bukan sesuatu yang boleh diserahkan pada nasib.

   Jadi markupnya memakai data-fdev-to, bukan data-counter, supaya berkas itu
   tidak pernah mengklaimnya. Cara mengurai angkanya sengaja disalin apa
   adanya dari sana, termasuk penanganan desimal dan pemisah ribuan, supaya
   98.2 dan 4,000 berperilaku sama di seluruh theme.

   KONTRAK NO-BREAK

   CSS TIDAK menyembunyikan apa pun secara bawaan. Aturan yang menyembunyikan
   digerbangi .fdev--live, dan kelas itu dipasang di sini, setelah semua
   pemeriksaan lolos. Tanpa JS, tanpa GSAP, dan di prefers-reduced-motion,
   seluruh batang, angka, dan kolom media tampil penuh. */
(function () {
  'use strict';

  /* Tag skripnya ada di dalam berkas section, jadi ikut terender dua kali
     kalau sectionnya dipasang dua kali di satu halaman. */
  if (window.__fslDevice) return;
  window.__fslDevice = true;

  var ns = window.FSL || {};
  var M = ns.motion;

  /* Registry, bukan listener sendiri. Dia menjalankan ulang pendaftarnya pada
     shopify:section:load, dan tanpa itu animasinya mati begitu section
     disunting di Theme Editor: markupnya diganti node baru sedangkan
     ScrollTrigger masih memegang node lama yang sudah dibuang. */
  if (!M || !M.gsap || !M.add) return;
  if (!window.ScrollTrigger) return;

  var gsap = M.gsap;

  /* Angka dari config __ix source, dalam detik. */
  var TUMBUH = 1;
  var TEKS = 0.3;
  var JEDA = 0.5;
  var NAIK = 0.6;
  var GESER = 50;

  /* Lama berhitung. Disamakan dengan penghitung global supaya angka di
     section ini punya ritme yang sama dengan angka di fsl-impact dan
     fsl-partnerships. Source tidak menyebut angkanya. */
  var HITUNG = 1.6;

  /* Sama dengan angka di stylesheet section: inset -10% dan height 120%. */
  var RUANG = 0.1;

  /* Geseran dinyatakan dalam yPercent, dan yPercent dihitung terhadap tinggi
     MEDIA, bukan tinggi wadah. Medianya 120% tinggi wadah, jadi ruang 10%
     tinggi wadah sama dengan 8.333% tinggi media.

     Dikali 0.9 dan bukan dipakai penuh. Pada nilai penuh tepi media mendarat
     persis di tepi wadah, dan pembulatan subpiksel di sana cukup untuk
     memunculkan garis rambut kosong.

     Turunannya ditulis sebagai pembagian, bukan 7.5 langsung, supaya
     hubungan ketiga angka tetap terbaca kalau RUANG diubah. Kalau RUANG
     diubah di sini, ubah juga inset dan height di stylesheet section. */
  var AMPLITUDO = (RUANG / 1.2) * 100 * 0.9;

  var URAI = /^(\D*?)([\d.,]+)(\D*)$/;

  /* Diurai dari teks, bukan dari setting number, dengan alasan yang sama
     seperti penghitung global: setting number kehilangan desimal dan pemisah
     ribuan, dan memaksa dua setting tambahan untuk awalan dan akhiran. */
  function urai(el) {
    var m = URAI.exec((el.getAttribute('data-fdev-to') || '').trim());
    if (!m) return null;

    var mentah = m[2];
    var angka = parseFloat(mentah.replace(/,/g, ''));
    if (isNaN(angka)) return null;

    var pecah = mentah.replace(/,/g, '').split('.');
    return {
      el: el,
      awal: m[1],
      akhir: m[3],
      target: angka,
      desimal: pecah.length > 1 ? pecah[1].length : 0,
      koma: mentah.indexOf(',') > -1
    };
  }

  function tulis(c, v) {
    var t = v.toFixed(c.desimal);
    if (c.koma) {
      var p = t.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      t = p.join('.');
    }
    c.el.textContent = c.awal + t + c.akhir;
  }

  /* Satu blok, satu fungsi, karena tiga tween di dalamnya berbagi closure.
     Menuliskannya inline di dalam for akan membuat onUpdate memakai nilai
     iterasi terakhir untuk semua blok. */
  function tambahTile(tl, tile, mulai) {
    var isi = tile.querySelector('.fdev__fill');
    var teks = tile.querySelector('.fdev__tile-text');
    var nilai = tile.querySelector('.fdev__value');

    /* Lebar dan bukan scaleX. scaleX memampatkan gradient dan mengubah sudut
       membulatnya jadi elips selama animasi. Lapisannya absolut dan tanpa
       anak, jadi lebar tidak menyeret tata letak apa pun. */
    if (isi) {
      tl.fromTo(
        isi,
        { width: '0%' },
        { width: '100%', duration: TUMBUH, ease: 'power2.inOut' },
        mulai
      );
    }

    if (teks) {
      tl.fromTo(
        teks,
        { opacity: 0 },
        { opacity: 1, duration: TEKS, ease: 'none' },
        mulai + JEDA
      );
    }

    var c = nilai ? urai(nilai) : null;
    if (!c) return;

    /* Nolnya ditulis sekarang, bukan dibiarkan sampai tweennya berjalan.
       Tanpa ini angka penuh sempat terlihat satu frame sebelum berhitung,
       dan yang terbaca bukan animasi tapi kedipan.

       Aman ditulis lebih awal karena teksnya masih opacity 0 sampai isyarat
       yang sama, jadi nol itu tidak pernah sampai ke mata. */
    tulis(c, 0);

    var kotak = { v: 0 };
    tl.to(
      kotak,
      {
        v: c.target,
        duration: HITUNG,
        ease: 'power2.out',
        onUpdate: function () { tulis(c, kotak.v); },
        /* Dipaksa mendarat tepat di target. Interpolasi float bisa berhenti
           di 99.999999, dan walau toFixed membulatkannya, lebih aman
           eksplisit. */
        onComplete: function () { tulis(c, c.target); }
      },
      mulai + JEDA
    );
  }

  function pasang(sec) {
    if (sec.dataset.fdevSiap === '1') return;
    sec.dataset.fdevSiap = '1';

    /* Reduced motion: keluar sebelum .fdev--live dipasang, jadi tidak ada
       satu pun aturan penyembunyi yang aktif dan seluruh angka serta batang
       tampil penuh seperti yang sudah dirender Liquid. Yang diminta pengguna
       itu tidak ada gerakan, bukan tidak ada informasi. */
    if (M.reduceMotion) return;

    var media = sec.querySelector('.fdev__media');
    var lapis = sec.querySelector('.fdev__layer');
    var tiles = [].slice.call(sec.querySelectorAll('.fdev__tile'));

    sec.classList.add('fdev--live');

    /* SATU TIMELINE UNTUK SEMUA BATANG, BUKAN SATU TRIGGER PER BATANG

       Jeda antar batang itu ritme, dan ritme cuma ada kalau semuanya
       berangkat dari satu jam yang sama. Trigger per batang membuat jaraknya
       ditentukan kecepatan gulir, jadi gulir cepat berarti tiga batang
       tumbuh berbarengan dan jenjangnya hilang.

       Jedanya diturunkan dari indeks, bukan dipatok tiga angka, karena
       jumlah bloknya bisa berapa saja. */
    if (tiles.length) {
      var tl = gsap.timeline({
        scrollTrigger: { trigger: sec, start: 'top 78%', once: true }
      });

      for (var i = 0; i < tiles.length; i++) {
        tambahTile(tl, tiles[i], i * JEDA);
      }
    }

    /* Naik masuk layar. Dipasang di WADAHNYA, sedangkan parallax di bawah
       dipasang di media di dalamnya. Dua transform di satu elemen akan saling
       menimpa, dan yang kalah adalah yang tweennya lebih dulu selesai. */
    if (media) {
      gsap.fromTo(
        media,
        { opacity: 0, y: GESER },
        {
          opacity: 1,
          y: 0,
          duration: NAIK,
          ease: 'power2.out',
          scrollTrigger: { trigger: media, start: 'top 88%', once: true }
        }
      );
    }

    /* Parallax. Satu arah, dari -AMPLITUDO ke 0, mengikuti source: medianya
       mulai tergeser ke atas lalu turun ke posisi diamnya sepanjang section
       melintasi viewport.

       Bedanya dengan fsl-value-features yang simetris di sekitar nol:
       di sini ruang lebih di sisi bawah tidak pernah terpakai. Itu kelebihan
       ruang, bukan kekurangan, jadi wadahnya tetap tertutup penuh di seluruh
       rentang dan tepi medianya tidak pernah masuk ke dalam bingkai.

       Satu fromTo dan bukan set lalu to. Nilai awal yang dipasang lewat
       gsap.set terpisah akan langsung ditimpa begitu tween scrub-nya
       menghitung frame pertama, jadi geseran awalnya hilang. */
    if (lapis) {
      gsap.fromTo(
        lapis,
        { yPercent: -AMPLITUDO },
        {
          yPercent: 0,
          ease: 'none',
          scrollTrigger: {
            trigger: sec,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
            invalidateOnRefresh: true
          }
        }
      );
    }
  }

  M.add(function (scope) {
    var s = scope || document;
    var daftar = s.querySelectorAll('.fdev');
    for (var i = 0; i < daftar.length; i++) pasang(daftar[i]);
  });
})();
